const useStyles = theme => ({
    fishTable: {
        width: '80%',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            marginTop: '1em',
            minHeight: '60vh',
            '& tbody': {
                verticalAlign: 'top',
            },
        },
        '& th': {
            fontSize: '1.2em',
            fontWeight: 'bold',
            paddingBottom: '1em',
            textDecoration: 'underline',
            textDecorationColor: '#00A8B6',
            textUnderlineOffset: '5px',
        },
        '& td': {
            fontSize: '1em',
            paddingBottom: '0.5em',
        },
    },
    teamName: {
        fontSize: '1.2em',
    },
    expandText: {
        color: '#00A8B6',
        fontSize: '0.7em',
        paddingLeft: '2em',
        cursor: 'pointer',
        fontWeight: 'bold',
    },
    teamTable: {
        width: '650px',
        padding: '1em',
        '& th': {
            fontSize: '1.5em',
            fontWeight: 'bold',
            paddingBottom: '1em',
        },
        '& td': {
            fontSize: '1.2em',
            paddingBottom: '0.5em',
        },
        [theme.breakpoints.down('xs')]: {
            width: '70vw',
            padding: '0em 1em 1em 1em',
            '& th': {
                fontSize: '1.2em',
                paddingBottom: '0.5em',
                whiteSpace: 'nowrap',
            },
            '& td': {
                fontSize: '0.8em',
                paddingBottom: '0.2em',
            },
        },
    },
    placeNum: {
        fontSize: '1.5em',
        fontWeight: 'bold',
    },
    points: {
        fontWeight: 'bold',
        fontSize: '1.5em',
    },
    dialogClButton: {
        color: '#00A8B6',
        backgroundColor: 'white',
        border: '1px solid #00A8B6',
        borderRadius: '5px',
        padding: '8px 10px 8px 10px',
        width: '100px',
        cursor: 'pointer',
        float: 'right',
        margin: '1em',
        fontWeight: 'bold',
    }
});

export default useStyles;